<template>
  <div>
    <el-card v-for="order in orders" :key="order.id" class="box-card">
      <div slot="header" class="clearfix">
        <span>
          {{ order.driverName || '---' }} {{ order.licenseNumber || '-------' }}
        </span>
        <span style="float: right; padding: 3px 0" type="text">
          {{ defaultOption.deliveryMethodLookup[order.deliveryMethod] }}
          {{ order.orderId }}
        </span>
      </div>
      <el-row style="line-height: 2">
        <el-col :span="5">
          <div>乘客: {{ order.userName }}</div>
          <div>人數: {{ order.seat || '1' }} 人</div>
          <div>上車地點: {{ order.onLocation }}</div>
          <div>下車地點: {{ order.offLocation }}</div>
        </el-col>
        <el-col :span="5">
          <div>
            輔助方式:
            {{ defaultOption.subsidyMethodLookup[order.subsidyMethod] }}
          </div>
          <div>自付比例: {{ order.payOwnselfProportion }}%</div>
          <div>上車時間: {{ parseTime(order.getOnDate) }}</div>
          <div>下車時間: {{ parseTime(order.getOffDate) }}</div>
        </el-col>
        <el-col :span="4">
          客服備註 {{ order.serviceNote }} 司機備註 {{ order.driverNote }}
        </el-col>
        <el-col :span="4">
          <div>里程數: {{ order.milage || 0 }}公里</div>
          <div>跳錶: {{ order.metreFare || 0 }}元</div>
          <div>輔助: {{ order.subsidyFare || 0 }}元</div>
          <div>實收: {{ order.actualFare || 0 }}元</div>
        </el-col>
        <el-col :span="6">
          驗證:
          {{
            defaultOption.verificationMethodLookup[order.verificationMethod] ||
            '--'
          }}
          <div>
            <img
              v-if="order.verificationPhoto"
              :src="order.verificationPhoto"
              alt="驗證圖"
              style="max-height: 150px"
            />
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :push="20" :span="4">
          <div style="display: flex; justify-content: space-around">
            <router-link
              v-if="order.orderStatus !== 5"
              :to="{
                name: 'editLongTermOrderForm',
                params: { orderId: order.orderId },
              }"
            >
              <el-button size="mini" round>修改</el-button>
            </router-link>
            <router-link
              :to="{
                name: 'longTermOrderDetail',
                params: { orderId: order.orderId },
              }"
            >
              <el-button type="primary" size="mini" round plain>檢視</el-button>
            </router-link>
            <el-button
              type="success"
              size="mini"
              round
              plain
              @click="confirmOrder(order.orderId)"
            >
              確認
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { defaultOption } from './defaultOption'
import longTermCareService from '@/API/longTermCareService'
import moment from 'moment'
const CONFIRM_STATE = 4
export default {
  props: {
    orders: Array,
  },
  data() {
    return { defaultOption }
  },
  methods: {
    parseTime(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    confirmOrder(id) {
      longTermCareService
        .updateOrderStatus(id, CONFIRM_STATE)
        .then((data) => {
          this.$message.success(data.message)
          this.$emit('reload')
        })
        .catch(({ data: { error }, message }) =>
          this.$message.error(message || error.message),
        )
    },
  },
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/_VerifyAwaitStatusOrderList.vue